<template>
  <error :headline="headline">
    <template slot="image">
      <img class="basketball" alt="basketball" src="../../assets/images/18a-lrn-spt-cat-1-icon-def.svg"/>
    </template>
    <template slot="message">
      <p>The page has returned an error and will not continue</p>
    </template>
  </error>
</template>

<script>
  import Error from '@/component/Error';

  export default {
    name: 'ErrorPage',

    components: {
      Error,
    },

    data: function () {
      return {
        headline: 'Missed Shot!',
      }
    },

    mounted: function () {
      this.interval = setTimeout(() => {
        this.$router.push({name: 'home'});
      }, 15000)
    },

    beforeRouteLeave (to, from, next) {
      clearInterval(this.interval);
      next();
    }
  };
</script>
